<template>
    <vue-hcaptcha :sitekey="sitekey" :size="size" :theme="theme"></vue-hcaptcha>
</template>

<script>
    import VueHcaptcha from '@hcaptcha/vue3-hcaptcha';

    export default {
        props: [
            'sitekey'
        ],

        data() {
            return {
                size: 'normal',
                theme: 'light',
            }
        },

        components: {
            VueHcaptcha
        }
    };
</script>
